import React, { useContext, useEffect, useState } from 'react'
import { Chart } from 'primereact/chart';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import Loader from '../../../Base/Components/Loader/Loader';
import Card from '../../../Base/Components/Card/Card';
import { formatNumber } from '../../../Base/Services/TemplatesServices';
import { ConfigContext } from '../../../Base/Context/ConfigContext/ConfigContext';

import { ResumenVentasPresMenTotal, ResumenVentasPresupuestoMensual } from '../../../API/Ventas/ResumenVentasRequest';
import { colorSintetico, datalabelsGerencia2, getTitle } from '../../../utils/KPIs/productionUtils';
import { Button } from 'primereact/button';
import { baseLang } from '../../../Base/Lang/BaseLang';
import { getLabel } from '../../../Base/Services/Language/LanguageService';
import { colorCotton } from '../../../Styles/Colors';
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid';
import { Dialog } from 'primereact/dialog';
import ResumenVentasDialog from './ResumenVentasDialog';
import DialogTablesVentasMensual from './DialogTablesVentasMensual';
import CalendarWeek from '../../../Base/Components/Form/CalendarWeek';

const ResumenVentasTotales = ({ date, kpiGerencia, getDatos, setShowModalMensuales, ventas = false }) => {


  const { config } = useContext(ConfigContext);

  const [loading, setLoading] = useState(false);
  const [showDialogDiario, setShowDialogDiario] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [idCustomer, setIdCustomer] = useState([]);
  const [dataTable, setDataTable] =  useState([]);
  const [showDialogTable, setShowDialogTable] = useState(false);
  const [fecha, setFecha] = useState(new Date())

  const colorTitle = getTitle(config);

  const [chart, setChart] = useState({
    data: {},
    options: {}
  });

  const getInfo = async () => {
    setLoading(true);
    const datosT =  await ResumenVentasPresMenTotal({Anio: date.getFullYear(), Mes: date.getMonth() + 1});
    setDataTable(datosT);
    const tempoAnual2 = await ResumenVentasPresupuestoMensual({ Anio: date.getFullYear(), Mes: date.getMonth() + 1});
    const data = [...tempoAnual2]
    const customerNames = data.map(item => item.CustomerName);

    let Ventas = []
    let Presupuesto= []
    let PorcentajeCumplimiento = []
    tempoAnual2.forEach((item) => {
      Ventas.push(item.Ventas);
      Presupuesto.push(item.Presupuesto);
      PorcentajeCumplimiento.push(item.PorcentajeCumplimiento)
    });
    
    let Mes = date.toLocaleString('es-ES', { month: 'long' })
    const monthName = Mes.charAt(0).toUpperCase() + Mes.slice(1);

    const ID = data.map(item => item.IdCustomer);

    setChart({
      data: {
        labels: customerNames,
        datasets: [
          {
            type: 'line',
            label: 'Budget',
            backgroundColor: colorCotton,
            borderColor: colorCotton,
            borderDash: [5, 5],
            data: Presupuesto,
          },
          {
            type: 'bar',
            label: 'Ventas',
            backgroundColor: colorSintetico,
            borderColor: colorSintetico,
            data: Ventas,
            data2: PorcentajeCumplimiento
          }
        ],
      },
      options: {
        interaction: {
          intersect: false,
          mode: 'index',
        },
        onClick: (event, elements) => {
          if (elements.length > 0) {
            const index = elements[0].index;
            const clickedCust = ID[index];
            setShowDialogDiario(true)
            setIdCustomer(clickedCust)
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: true,
            text: `${getLabel(baseLang, "ventasMiles", config.language)}` +  monthName  + ' / ' + date.getFullYear(),
            color: colorTitle,
            padding: {
              top: 10,   
              bottom: 40  
            },
          },
          datalabels: datalabelsGerencia2,
          aspectRatio: 5 / 3,
          elements: {
            line: {
              fill: false,
              tension: 0.4
            }
          },
          legend: {
            position: 'bottom',
            labels: {
              color: colorTitle,
              font: {
                size: 11,
              },
            },
          },
          tooltip: {
            callbacks: {
              footer: (tooltipItems) => {
                const index = tooltipItems[0].dataIndex;
                const porcentaje = tooltipItems[1]?.dataset?.data2[index];
                return `Cumplimiento: ${porcentaje} %`;
              },
            },
          },
        },
        scales: {
          x: {
            stacked: true,
            ticks: {
                color: colorTitle,
                minRotation: 90,
                maxRotation: 90,
                color: getTitle(config),
                font: {
                  size:  10.5
                },
              }
            },
          y: {
            ticks: {
              color: getTitle(config),
              callback: (val, index) => {
                return (val > 0 ? '$ ' + formatNumber(val).replace('.00', '') : '')
              }
            }
          }          
        },
      }
    });
    setLoading(false);
  }

  const colums = [
    // {
    //     header: 'Año',
    //     field: 'Anio',
    //     className: 'small'
    // },
    {
      header: 'Cliente',
      field: 'CustomerName',
      flex:1
      // className: 'small'
    },
    {
      header: 'Presupuesto',
      field: 'Presupuesto',
      className: 'large',
      Format:'Currency',
      Sumary: 'sum',
    },
    {
      header: 'Ventas',
      field: 'Ventas',
      className: 'large',
      Format:'Currency',
      Sumary: 'sum',
    },
    {
      header: '% Cumplimiento',
      field: 'PorcentajeCumplimiento',
      className: 'large',
      Format:'Porcentaje',
    }
]

const table = {
    Data: dataTable,
    Columns: colums
}

  useEffect(() => {
    getInfo();
  }, [date, config])

  useEffect(() => {
    if (getDatos) {
      getInfo()
    }
  }, [getDatos])

  const abrirDialog = () =>{
    if(ventas){
      setShowDialog(true)
    }else{
      setShowModalMensuales(true)
    }
  }

  return (
    <div id='resumenVentasAnual'>
      <Loader loading={loading} querySelector={'#resumenVentasAnual'} />
      <Card
        titulo={
          <div className='d-flex'>
            {/* <h4 className='mt-2'>Ventas por Cliente</h4> */}
            <h4 className='mt-2'>{getLabel(baseLang, "ventasCliente", config.language)}</h4>
            {kpiGerencia &&
            <div>
              <Button
                className="p-button-text mx-2"
                style={{ zIndex: 1000 }}
                tooltip={getLabel(baseLang, "ventasCliente", config.language)}
                icon='pi pi-eye'
                onClick={abrirDialog}
              />
              <Button
                className="p-button-text mx-2"
                style={{ zIndex: 1000 }}
                tooltip={getLabel(baseLang, "ventasCliente", config.language)}
                icon='pi pi-table'
                onClick={e => setShowDialogTable(true)}
              />
              </div>
            }
          </div>
        }
        contenido={
          <div style={kpiGerencia ? { display: 'flex' } : {}}>
            <div className='col-12' style={{ flex: 1 }}>
              <Chart height={ventas ? '80vh': '378px'} width='100%' type='bar' data={chart.data} options={chart.options} plugins={[ChartDataLabels]} />
              {ventas && (
              <div className='p-2' style={{ height: '35vh' }}>
                  <AgGrid table={table} />
              </div>
              )}
            </div>
          </div>
        } />

        <Dialog
            visible={showDialog}
            onHide={() => {setShowDialog(false)}}
            maximized={true}
             maximizable={true} 
            closeOnEscape={false}
            style={{ width: '100%'}}
            resizable={false}
            header={<h4>{`${getLabel(baseLang, "ventasMesuales", config.language)} / ${date.getFullYear()} ($)`}</h4>}
        >
          <ResumenVentasDialog kpiGerencia={true} date={date} getDatos={getInfo} altura={true} />
        </Dialog>

        <Dialog visible={showDialogTable} onHide={() => setShowDialogTable(false)} maximizable={true} maximized={true} style={{ width: '100%' }} resizable={true}
          header={<div>
             <CalendarWeek date={fecha} setDate={e => setFecha(e)} view="month" dateFormat="mm/yy" />
          </div>}
          >
          <DialogTablesVentasMensual date={fecha} />
        </Dialog>
    </div>
  );
};

export default ResumenVentasTotales;
